import { Controller } from "@hotwired/stimulus";
import BeefreeSDK from '@beefree.io/sdk';

let editorBuilder;

const beeConfig = {
  uid: "defaultUID", //needed for identify resources of the that user and billing stuff
  container: 'bee-plugin-container', //Identifies the id of div element that contains BEE Plugin
  language: 'en-US',
  defaultColors: ['#ffffff', '#3d413d', '#e5e5e5'],
  onSave: (jsonFile, htmlFile) => {
    updateForm(objectId, jsonFile, htmlFile)
  },
  onSaveAsTemplate: (jsonFile) => {

  },
  onSend: (htmlFile) => {
    //console.log('onSend', htmlFile)
  },
  onError: (errorMessage) => {
    console.log('onError ', errorMessage)
  },

  onWarning: (errorMessage) => {
    console.log('onWarning ', errorMessage)
  },

  titleDefaultConfig: {
    bold: true
  },
  titleDefaultStyles: {
    h1: {
      color: '#3d413d',
      'font-size': '40px',
      'font-weight': '900',
      'line-height': '120%',
      'text-align': 'left'
    },
    h2: {
      color: '#3d413d',
      'font-size': '36px',
      'font-weight': '900',
      'line-height': '120%',
      'text-align': 'left'
    },
    h3: {
      color: '#3d413d',
      'font-size': '32px',
      'font-weight': '900',
      'line-height': '120%',
      'text-align': 'left'
    },
  },


  contentDefaults: {
    general: {
      messageWidth: "1136px",
      backgroundColor: "transparent",
      contentAreaBackgroundColor: "transparent",
      fontFamily: "Inter, Helvetica Neue, Helvetica, Arial, sans-serif",
      linkColor: "#3d413d"
    },
    title: {
      hideContentOnMobile: false,
      defaultHeadingLevel: 'h3',
      blockOptions: {
        align: 'left',
        paddingTop: "24px",
        paddingBottom: "24px",
      },
    },
    divider: {
      width: '100%',
      line: "1px solid #e5e5e5",
      align: "left",
      blockOptions: {
        paddingBottom: "15px",
        paddingLeft: "25px",
        paddingRight: "25px",
        paddingTop: "15px",
        hideContentOnMobile: false
      }
    },
    button: {
      label: "Button",
      href: "https://educationhouse.org",
      styles: {
        color: "#ffffff",
        fontSize: '16px',
        fontFamily: "Inter, Helvetica Neue, Helvetica, Arial, sans-serif",
        backgroundColor: "#3d413d",
        borderBottom: "0px solid transparent",
        borderLeft: "0px solid transparent",
        borderRadius: "8px",
        borderRight: "0px solid transparent",
        borderTop: "0px solid transparent",
        lineHeight: "150%",
        maxWidth: "100%",
        paddingBottom: "5px",
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingTop: "5px"
      },
      blockOptions: {
        paddingBottom: "15px",
        paddingLeft: "25px",
        paddingRight: "25px",
        paddingTop: "15px",
        align: "center",
        hideContentOnMobile: false
      }
    },
    text: {
      html: 'This is default text for block...',
      styles: {
        color: "#3d413d",
        linkColor: "#3d413d",
        fontSize: "18px",
        lineHeight: "150%",
      },
      blockOptions: {
        paddingBottom: "0px",
        paddingLeft: "0px",
        paddingRight: "0px",
        paddingTop: "0px",
        hideContentOnMobile: false
      },
    },
    paragraph: {
      styles: {
        color: '#3d413d',
        fontSize: '18px',
        fontFamily: 'inherit',
        fontWeight: '400',
        lineHeight: '150%',
        textAlign: 'left',
        direction: 'ltr',
        letterSpacing: '0px',
        linkColor: '#0068a5',
        paragraphSpacing: '16px'
      },
      blockOptions: {
        paddingTop: '0px',
        paddingRight: '0px',
        paddingBottom: '0px',
        paddingLeft: '0px'
      },
    },
    list: {
      styles: {
        color: '#3d413d',
        fontSize: '18px',
        fontFamily: 'inherit',
        fontWeight: '400',
        lineHeight: '150%',
        textAlign: 'left',
        direction: 'ltr',
        letterSpacing: '0px',
        linkColor: '#3d413d',
        liSpacing: '0px',
        liIndent: '40px',
        listType: 'ul', // or 'ol'
        listStyleType: 'revert',
        startList: '1',
      },
      blockOptions: {
        paddingTop: '10px',
        paddingRight: '10px',
        paddingBottom: '10px',
        paddingLeft: '10px',
      },
    }
  },
}

let objectId;
let objectType;
let objectTitle;
let objectToken;

export default class extends Controller {
  static targets = [ "body" ]

  connect() {
    objectId = this.data.get("id");
    objectType = this.data.get("type");
    objectTitle = this.data.get("title");
    objectToken = this.data.get("token");

    let url = objectType + "s/"

    fetch( "/" + url + objectId + ".json")
    .then(data => {return data.json();})
    .then(json =>{

      if (json == null)
        json = {"page":{"body":{"container":{"style":{"background-color":"transparent"}},"content":{"computedStyle":{"linkColor":"#3d413d","messageBackgroundColor":"transparent","messageWidth":"1136px"},"style":{"color":"#3d413d","font-family":"Inter, Helvetica Neue, Helvetica, Arial, sans-serif"}},"type":"mailup-bee-page-proprerties"},"description":"Test template","rows":[{"columns":[{"grid-columns":12,"modules":[],"style":{"background-color":"transparent","border-bottom":"0px solid transparent","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"0px solid transparent","padding-bottom":"20px","padding-left":"0px","padding-right":"0px","padding-top":"20px"},"uuid":"f5a138e5-bad4-49c3-a2a6-d5b862a42abf"}],"container":{"style":{"background-color":"transparent","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"style":{"background-color":"transparent","background-image":"none","background-position":"top left","background-repeat":"no-repeat","color":"#3d413d","width":"1136px"}},"type":"one-column-empty","uuid":"bda7b744-1fca-46eb-a1a0-1fa0fa792892"}],"template":{"name":"template-base","type":"basic","version":"0.0.1"},"title":"Template Base"},"comments":{}};

      editorBuilder = new BeefreeSDK(JSON.parse(objectToken));
      editorBuilder.start(beeConfig, json);

    })
  }

  saveData(event) {
    editorBuilder.save();
  }
} 

function updateForm(id, jsonFile, htmlFile) {
  let data = {[objectType]: {"body_json": jsonFile, body: htmlFile}};
  let url = objectType + "s/"

  fetch( "/" + url + objectId + ".json", {
    method: "PUT",
    headers: {
      "X-CSRF-Token": document.head.querySelector("meta[name=csrf-token]")?.content,
      'Content-Type': 'application/json'
    },
    credentials: "same-origin",
    body: JSON.stringify(data),
  }).then(function(response) {
    document.body.querySelector('md-dialog').close();
    Turbo.visit(document.location);
  })
}